import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";


const AboutSection = () => {

  const [about, setAbout] = useState([]);
  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/about`)
      .then((res) => res.json())
      .then((info) => setAbout(info));
  }, []);

  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);





  return (



    <>
      {
        about.map(b => b.pageSlug === page.pageSlug &&

          <section id="about-sec" className="content-2 wide-60 content-section division">
            <div className="container">
              <div className="row d-flex align-items-center">
                {/* IMAGE BLOCK */}
                <div className="col-md-5 col-lg-6">
                  <div className="img-block left-column pc-25 mb-40 wow fadeInRight" data-wow-delay="0.4s">
                    <img className="img-fluid" src={b.aboutImgOne} alt="content-image" />
                  </div>
                </div>
                {/* TEXT BLOCK */}
                <div className="col-md-7 col-lg-6">
                  <div className="txt-block right-column pc-35 mb-40 wow fadeInLeft" data-wow-delay="0.4s">
                    {/* Title */}
                    <h3 className="h3-sm"> {b.aboutHeading}</h3>
                    {/* Text */}
                    <p className="grey-color">{b.aboutText}
                    </p>
                    {/* Text List */}
                    <ul className="txt-list grey-color">
                      <li className="list-item">
                        <i className="fas fa-angle-right" />
                        <p className="p-md">{b.pointOne}
                        </p>
                      </li>
                      <li className="list-item">
                        <i className="fas fa-angle-right" />
                        <p className="p-md">{b.pointTwo}
                        </p>
                      </li>
                      <li className="list-item">
                        <i className="fas fa-angle-right" />
                        <p className="p-md">{b.pointThree}
                        </p>
                      </li>
                    </ul>	{/* End Text List */}
                  </div>
                </div>	{/* END TEXT BLOCK */}
              </div>	  {/* End row */}
            </div>     {/* End container */}
          </section>


        )
      }



    </>



  );
};

export default AboutSection;
